import React, {
    useState
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import CameraRepository from "../../../repositories/CameraRepository";
import {
    BooleanGridColumnType,
    ActionButtons,
    ActionButtonTypes,
    buildActionButton
} from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";

const CameraListView = () => {

	const navigate = useNavigate();
	const repository = new CameraRepository();
	const {t}  = useTranslation();
	const [blockedWindow, setBlockedWindow] = useState(false);

	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      },
      {
        value: 'Code|asc',
        label: t('Code') + ' (A-Z)'
      },
      {
        value: 'Code|desc',
        label: t('Code') + ' (Z-A)'
      }
    ];

    const handleEditItemClick = (event) => {
	    navigate("/app/cameras/" + event.Id);
    }

	const {items, totalCount, itemsOnPage, onDeleteHandler, onEditHandler, onPage, isSearching, onFilterChangedHandler, onSortChangedHandler, filter, sort, updateGrid } = useGrid(repository, { onEdit: handleEditItemClick, defaultSort: sortOptions[0].value });

	const columns = [
      { field: 'Id', headerName: t('ID'), width: 70, sortable: false },
      { field: 'Code', headerName: t('Code'), width: 130, sortable: false  },
      { field: 'ParkingZoneName', headerName: t('Parking zone'), width: 200, sortable: false  },
      { field: 'CameraSetName', headerName: t('Set'), width: 200, sortable: false  },
      {
          field: 'IsActive',
          headerName: t('Active'),
          width: 100,
          sortable: false,
          ... BooleanGridColumnType
      },
      {
          headerName: t('Actions'),
          field: 'edit',
          ...ActionButtons([buildActionButton(ActionButtonTypes.EDIT, t("Edit"), onEditHandler), buildActionButton(ActionButtonTypes.DELETE, t("Delete"), onDeleteHandler)])
      }
    ];

	return (
	    <GridSkeleton title={t("Cameras")}
                      isSearching={isSearching}
                      isBlocked={blockedWindow}
                      header={(<Header onRefresh={updateGrid} />)}
                      filter={(<FilterBar sortOptions={sortOptions} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort} />)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default CameraListView;
